<template>
  <a-drawer
    v-if="guideResultVisile"
    v-model:visible="guideResultVisile"
    wrapClassName="guide-drawer"
    title="填写导诊结果"
    placement="right"
    width="391"
    :bodyStyle="{ padding: 0 }"
  >
    <div class="record-tips" v-if="haveDoctor && isSupplyed">
      <span v-if="showTips">
        如患者已门诊就诊，请为患者
        <span class="link" @click="ToMedicalRecord">补充诊疗记录>></span>
      </span>
      <span v-else>已为患者补充诊疗记录</span>
    </div>
    <div class="content-wrap">
      <a-form ref="formRef" :rules="rules" :model="formState" layout="vertical">
        <a-form-item label="结果类型" name="followRecordType">
          <a-select
            style="width: 100%"
            placeholder="请选择"
            v-model:value="formState.followRecordType"
            :options="resultTypeOptions"
          ></a-select>
        </a-form-item>

        <a-form-item label="下次跟踪时间" name="unFollowRecord" style="margin-bottom: 10px">
          <a-radio-group
            style="margin-bottom: 14px"
            v-model:value="formState.unFollowRecord"
            @change="radioChange"
          >
            <a-radio value="0">需要跟踪</a-radio>
            <a-radio value="1">无需跟踪</a-radio>
          </a-radio-group>
          <a-form-item
            label=""
            v-if="formState.unFollowRecord === '0'"
            name="followRecordNextTime"
            :rules="[{ required: formState.unFollowRecord === '1', message: '请选择跟踪时间' }]"
            style="margin-bottom: 10px"
          >
            <a-date-picker
              style="width: 100%; margin-bottom: 0px"
              v-model:value="formState.followRecordNextTime"
              :disabled-date="disabledDate"
            />
          </a-form-item>
          <!-- <div class="tips" v-if="formState.followRecordNextTime">
            <InfoCircleOutlined style="color: #bababa" />
            系统将在
            <span style="color: #ffa940">14天后</span>
            生成需求跟踪工单
          </div> -->
        </a-form-item>

        <a-form-item label="备注" name="remark">
          <a-textarea
            v-model:value="formState.remark"
            showCount
            :maxlength="200"
            placeholder="请输入～（非必填）"
            allow-clear
          />
        </a-form-item>
      </a-form>
    </div>
    <div class="footer">
      <a-button @click="guideResultVisile = false" style="margin-right: 8px">取消</a-button>
      <a-button type="primary" @click="submitForm">提交</a-button>
    </div>
  </a-drawer>
</template>

<script setup>
import { defineExpose, ref, defineProps, defineEmits, computed, reactive } from 'vue'
import {
  followResultEnumList,
  submitFollowRecord,
  getPatientDiseaseForRequire
} from '@/api/workPlace/workOrder'
import moment from 'moment'

const prop = defineProps({
  info: {
    type: Object,
    default: () => {}
  },
  curGroupInfo: {
    type: Object,
    default: () => {}
  }
})

const guideResultVisile = ref(false)
const groupInfo = computed(() => prop.curGroupInfo)
const haveDoctor = computed(() => groupInfo.value?.doctorInfo?.ucUserId)
const showTips = ref(true)
const isSupplyed = ref(true)
const resultTypeOptions = ref([])
const formRef = ref()

const disabledDate = current => {
  const oneYearLater = moment().add(365, 'days')
  return (current && current < moment()) || current > oneYearLater
}

const formState = reactive({
  followRecordType: undefined,
  unFollowRecord: null,
  followRecordNextTime: null,
  remark: ''
})
const rules = {
  followRecordType: [
    {
      required: true,
      message: '请选择结果类型',
      trigger: 'change'
    }
  ],
  unFollowRecord: [
    {
      required: true,
      message: '请选择是否下次跟踪时间',
      trigger: 'change'
    }
  ]
}

const initModal = () => {
  showTips.value = true
  guideResultVisile.value = true
  resultTypeOptions.value = []
  formState.followRecordType = null
  formState.unFollowRecord = null
  formState.followRecordNextTime = null
  formState.remark = ''
  // 查询枚举
  followResultEnumList({
    businessType: prop.info.businessType
  }).then(res => {
    const result = res.length ? res : []
    result.forEach(element => {
      resultTypeOptions.value.push({
        value: String(element.id),
        label: element.name
      })
    })
  })
  if (haveDoctor.value) {
    getPatientDiseaseForRequire({
      workOrderId: prop.info.workOrderId,
      ucPatientId: groupInfo.value?.patientInfo?.ucUserId,
      ucDoctorId: groupInfo.value?.doctorInfo?.ucUserId || 0
    }).then(res => {
      isSupplyed.value = res
    })
  }
}

const closeModal = () => {
  guideResultVisile.value = false
}

const radioChange = e => {
  if (e.target.value === '0') {
    formState.followRecordNextTime = moment().add(14, 'days').format('YYYY-MM-DD')
  }
  if (e.target.value === '1') {
    formState.followRecordNextTime = null
  }
}

const emit = defineEmits(['supplayMedicalRecord', 'completeBuss'])
const ToMedicalRecord = () => {
  emit('supplayMedicalRecord')
}

const submitForm = () => {
  formRef.value.validate().then(() => {
    const params = {
      ucPatientId: groupInfo.value?.patientInfo?.ucUserId,
      ucDoctorId: groupInfo.value?.doctorInfo?.ucUserId || 0,
      businessWorkOrderId: prop.info.workOrderId,
      unFollowRecord: Number(formState.unFollowRecord),
      followRecordType: Number(formState.followRecordType),
      followRecordDetail: resultTypeOptions.value.find(
        item => item.value === formState.followRecordType
      )?.label,
      followRecordNextTime: formState.followRecordNextTime
        ? moment(formState.followRecordNextTime).format('YYYY-MM-DD')
        : null,
      remark: formState.remark
    }
    console.log('params', params)
    submitFollowRecord(params).then(() => {
      guideResultVisile.value = false
      emit('completeBuss')
    })
  })
}

defineExpose({
  initModal,
  closeModal,
  guideResultVisile,
  showTips
})
</script>
<style></style>
<style lang="scss" scoped>
.guide-drawer {
  .record-tips {
    line-height: 42px;
    background: #fff5ea;
    padding: 0 16px;
    font-weight: 500;
    font-size: 14px;
    color: #333333;
  }
  .link {
    color: #1890ff;
    cursor: pointer;
  }

  .content-wrap {
    padding: 24px;

    .formItem {
      margin-bottom: 20px;

      .formLabel {
        font-weight: 500;
        font-size: 14px;
        color: #333333;
        margin-bottom: 8px;
      }

      .tips {
        color: #bababa;
        font-size: 12px;
        font-weight: 400;
        line-height: 14px;
      }
    }
  }

  .footer {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 100%;
    border-top: 1px solid #e9e9e9;
    padding: 10px 16px;
    background: #fff;
    text-align: right;
    z-index: 1;
  }
}
</style>
